import React from 'react';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import Subheader from 'material-ui/Subheader';

import styles from '../../styles';

const Collapse = ({ children, initiallyExpanded, header }) => (
  <Card initiallyExpanded={initiallyExpanded} style={styles.card}>
    <CardHeader
      title={
        <Subheader
          style={{
            // color: "#33691e",
            // border: "2px solid #33691e",
            // borderRadius: "4px",
            margin: '1.5rem',
            textAlign: 'center',
            padding: '0'
          }}>
          {header}
        </Subheader>
      }
      actAsExpander
      showExpandableButton
      style={{ padding: 0, backgroundColor: '#fafafa' }}
    />
    <CardText expandable>{children}</CardText>
  </Card>
);

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Collapse.js